/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import type { History } from 'history'
import hoistNonReactStatics from 'hoist-non-react-statics'
import React from 'react'
import type { GetProps, InferableComponentEnhancerWithProps } from 'react-redux'
import { useHistory } from 'react-router-dom'

/**
 * Similar to `withRouter`, but only injects the `history` prop. Unlike `location` and `match`
 * (the other 2 route props), `history` never changes, so this helps avoid re-renders
 */
// @ts-expect-error
export const withHistory: InferableComponentEnhancerWithProps<
  { history: History<unknown> },
  { [k: string]: never }
> = (OriginalComponent) => {
  const WrappedComponent = (props: Omit<GetProps<typeof OriginalComponent>, 'history'>) => {
    const history = useHistory()
    // @ts-expect-error
    return <OriginalComponent {...props} history={history} />
  }
  hoistNonReactStatics(WrappedComponent, OriginalComponent)
  return WrappedComponent
}
